// ─────────────────────────────────────────────────────────────────────────────
// 🔑 DOORLYDESK'S LETTER SEND-BACK FORM (staff-facing — Jesse 2026-11-02). The borrower sees staff's message exactly as
// written, under the approved card title and "What’s needed:" (backend utils/loxSendBack). Required, at least
// NOTE_MIN_CHARS characters once trimmed — the server route refuses the same (backend constants/loxSendBackCopy; the
// backend test checks the two files agree).
// ─────────────────────────────────────────────────────────────────────────────
export const NOTE_MIN_CHARS = 10;
export const STAFF_NOTE_LABEL = 'Message to the borrower (they’ll see this exactly as written)';
export const noteTooShort = (note) => String(note || '').trim().length < NOTE_MIN_CHARS;
